<template>
        <div class="box">
                <!-- 遮罩 -->
                <div class="box1"  @click="Hidden" >

                </div>
                <!-- 内容 -->
                <div class="box2">
                    <div class="box3">
                        签到规则
                    </div>
                    <div class="box4">
                        <div class="box4_1">
                            1、每天可签到，签到即可获得相应的打卡记录，打卡次数用于证明您使用师讯平台的频次，签到次数不可用于任何形式的购买兑换
                        </div>
                        <div class="box4_1">
                            2、若签到漏签，则不可进行补签，可继续进行签到，但签到数量将从第一天开始推算
                        </div>
                        <div class="box4_1">
                            3、连续签到7天之后，可持续签到，数量将延续累加
                        </div>
                    </div>
                    <div @click="Hidden" class="box5">
                        好的，知道了
                    </div>
                </div>
            </div>
</template>
<script>
export default {
    data(){
        return{
        }
    },
    methods:{
        Hidden(){
            this.$emit('hidden')
        }
    }
}
</script>
<style lang="scss" scoped>
.box{

}


.box1{
    position: fixed;
    top: 0;
    width: 100%;
    height: 100vh;
    background: #000;
    opacity: .5;
    z-index: 110;
}

@keyframes mybox2{
    0% {
    //    left: 0;
        opacity: 0;
    }
    100%{
    //    left: 50%;

    }


}

.box2{
    width: 249px;
    // height: 268px;
    background: #FFFFFF;

    border-radius: 8px;
    z-index: 110;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    animation: mybox2 .5s;
}

.box3{
    margin-top: 12px;
    margin-bottom: 6px;
    font-size: 16px;
    font-weight: 400;
    color: #FF3A3A;

    text-align: center;
}

.box4_1{
    margin-bottom: 12px;
    font-size: 11px;
    font-weight: 400;
    // color: #333333;

    color: #5B616C;
    letter-spacing: 2px;

}

.box5{
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
    border-top: 1px solid #EEF2F3;

    font-size: 14px;
    font-weight: 400;
    color: #333333;

    margin-top: 16px;
}

</style>
